import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '@services/settings/app-settings.service';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';
import { MailHistoryItem } from '../../services/mail-management.service';

@Component({
  selector: 'app-mail-list',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbTooltipModule, ListCardComponent],
  templateUrl: './mail-list.component.html',
  styleUrl: './mail-list.component.scss'
})
export class MailListComponent {
  readonly appSettings = inject(AppSettings);

  @Input() items: MailHistoryItem[] = [];
  @Input() loading = false;
  @Input() loadingMore = false;
  @Input() selectedUuid: string | null = null;
  @Input() total = 0;
  @Input() searchQuery = '';
  @Input() activeStatus: string | null = null;

  @Output() searchQueryChange = new EventEmitter<string>();
  @Output() activeStatusChange = new EventEmitter<string | null>();
  @Output() selectMail = new EventEmitter<MailHistoryItem>();
  @Output() loadMore = new EventEmitter<void>();

  statusFilters = [
    { slug: null, name: 'Todos' },
    { slug: 'SENT', name: 'Enviados' },
    { slug: 'FAILED', name: 'Fallidos' },
    { slug: 'SKIPPED', name: 'Omitidos' }
  ];

  // Emite cambio del termino de busqueda
  onSearch(value: string): void {
    this.searchQueryChange.emit(value);
  }

  // Conmuta filtro por estado
  toggleStatus(status: string | null): void {
    const next = this.activeStatus === status ? null : status;
    this.activeStatusChange.emit(next);
  }

  // Notifica seleccion de un correo
  onSelect(item: MailHistoryItem): void {
    this.selectMail.emit(item);
  }

  // Emite evento de carga al acercarse al fondo de la lista
  onScroll(event: Event): void {
    const el = event.target as HTMLElement;
    if (!el || this.loading || this.loadingMore) return;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 120) {
      this.loadMore.emit();
    }
  }
}
